//Hardware revision number to UAV name map
export const UAV_HR_TO_NAME: { [key: number]: string } = {
  0: 'Tron V1',
  1: 'Trinity V1',
  2: 'Tron PFG',
  3: 'Trinity F9',
  5: 'Trinity F90+',
  6: 'Vector V1',
  7: 'Vector Copter V1',
  8: 'Tron F90+', // Note: Duplicate key in enum, choosing "Tron F90+"
  9: 'Vector F9',
  10: 'Vector Copter F9',
  11: 'Vector 2in1',
  19: 'Trinity Pro',
  20: 'Trinity Tactical',
  21: 'Vector 2in1 Skynode',
  22: 'Vector Skynode',
  23: 'Scorpion Skynode',
  25: 'Twister',
  26: 'Vector R24',
  99: 'Unknown',
};
